export default __webpack_public_path__ + "62b8fe4be97b253ee226baff9e1fb1b8.svg";